import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonus" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-17" data-mp="authf9yat5xk">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="fs3ftf3o0rxj">
          🎁 5 Bonus Gratuits Inclus
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm font-bold uppercase tracking-wide text-grape" data-id="element-19" data-mp="5w8q6010xwl9">
          Aujourd'hui seulement
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3o3porp60vcr4">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-4 rounded-2xl border border-grape/20 bg-cream p-6" style={{
          paddingTop: "16px",
          paddingBottom: "16px"
        }} data-id="element-21" data-mp="3t0yce59xw8zr" data-mpi={i}>
              <img src={b.cover} alt={`Couverture du bonus ${b.title}`} width={1122} height={1402} loading="lazy" decoding="async" sizes="112px" className="h-auto w-24 shrink-0 self-start rounded-lg object-contain drop-shadow-[0_10px_18px_rgba(15,42,29,0.28)] sm:w-28" data-id="element-22" data-mp="3r6i5mvh7vb7y" />
              <div className="flex min-w-0 flex-col" data-id="element-23" data-mp="2zhojyi81p5qz">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-24" data-mp="2uhivfax2nzd4">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-25" data-mp="38gikgjohyg9t">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-26" data-mp="33jies9vk7fj8" /> Bonus {b.n}
                  </span>
                  <span className="whitespace-nowrap text-sm font-bold" data-id="element-27" data-mp="ns49s7l5i48r">
                    <span className="text-plum/40" data-id="element-28" data-mp="iq5955gsplfi">Valeur </span>
                    <span className="text-plum/40 line-through" data-id="element-29" data-mp="3cjg05gwosxl1">{b.price}</span>{' '}
                    <span className="text-blush-deep" data-id="element-30" data-mp="3hhr8fn7c3015">GRATUIT</span>
                  </span>
                </div>
                <h3 className="text-base font-bold text-plum" data-id="element-31" data-mp="3lj334752ebg7">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-32" data-mp="3qipdm8tiddlb">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-blush/40 bg-blush-soft p-6 text-center" style={{
        paddingTop: "11px",
        paddingBottom: "11px"
      }} data-id="element-33" data-mp="2ttgc8xcl1oj7">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-34" data-mp="32t3d9i1egsbq">
            💰 Valeur totale des bonus : <span className="text-plum/50 line-through" data-id="element-35" data-mp="37jtlr454hban">118 €</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-36" data-mp="37lwl4es60gs1">
              AUJOURD'HUI GRATUIT AVEC REHAB 360™
            </span>
          </p>
        </div>
      </div>
    </section>;
}